
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Pourquoi je ne trouve pas mon entreprise sur Google ?",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Votre site est en ligne, mais il n'apparaît pas sur Google ? Découvrez les raisons possibles et les solutions pour améliorer votre visibilité en ligne.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Pourquoi je ne trouve pas mon entreprise sur Google ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous avez créé et mis en ligne votre site Internet. Pourtant, vous n’apparaissez pas sur Google. Que se passe-t-il ? Menons l’enquête, avec vous.",
        },
      ],
    };
  },
};
